import DuplicateStage from './DuplicateStage';
import './DuplicateStage.scss';

export default DuplicateStage;
